import { ContractRoleService } from './../../../../../../shared/service/contract-role.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { CustomValidator } from 'src/app/shared/directive/custom-validator';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { RoleService } from 'src/app/shared/service/role.service';
import { ROLE } from '../contract-access/contract-access.component';

@Component({
  selector: 'app-create-edit-contract-access',
  templateUrl: './create-edit-contract-access.component.html',
  styleUrls: ['./create-edit-contract-access.component.scss']
})
export class CreateEditContractAccessComponent implements OnInit {

  roleForm: FormGroup;
  isEdit = false;
  roles = ROLE;
  id: number;
  accessTypeOptions = [
    {
      value: true,
      display: 'All Contract Types',
    },
    {
      value: false,
      display: 'SMS Contract Type Only',
    },
  ]
  constructor(
    private spinner: Spinner,
    private activatedRoute: ActivatedRoute,
    private contractRoleService: ContractRoleService,
    private roleService: RoleService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.activatedRoute.params.subscribe(res => {
      if (res.id) {
        this.getUserById(res.id);
        this.isEdit = true;
      }
    });
   }

  ngOnInit() {
    this.initForm();
  }

  public getUserById(id) {
    this.spinner.show();
    this.contractRoleService.getUserById(id).subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        const model = {
          sso: res.data.sso,
          fullName: res.data.fullName,
          email: res.data.email,
          roles: res.data.roles[0],
          isPrimary: res.data.isPrimary,
          accessType: res.data.accessType,
        };
        this.id = res.data.id;
        this.initForm(model);
      }
    });
  }

  public initForm(model?) {
    if (model) {
      console.log(model);
      this.roleForm = new FormGroup({
        sso: new FormControl(model.sso, [CustomValidator.required]),
        fullName: new FormControl(model.fullName),
        email: new FormControl(model.email),
        roles: new FormControl(model.roles, [CustomValidator.required]),
        isPrimary: new FormControl(model.isPrimary),
        accessType: new FormControl(model.accessType),
      });
    } else {
      this.roleForm = new FormGroup({
        sso: new FormControl('', [CustomValidator.required]),
        fullName: new FormControl(),
        email: new FormControl(),
        roles: new FormControl('', [CustomValidator.required]),
        isPrimary: new FormControl(false),
        accessType: new FormControl(false),
      });
    }
  }

  search() {
    this.spinner.show();
    this.contractRoleService.checkSSO(this.roleForm.controls.sso.value).subscribe(res => {
      this.spinner.hide();
      if (res.data.length > 0) {
        this.roleForm.controls.fullName.setValue(res.data[0].fullName);
        this.roleForm.controls.email.setValue(res.data[0].email);
      } else {
        this.toastr.error(MESSAGE_TOAST.SSO_NOT_FOUND);
        this.roleForm.controls.sso.setValue('');
        this.roleForm.controls.fullName.setValue('');
        this.roleForm.controls.email.setValue('');
      }
    });
  }

  save() {
    if (this.roleForm.invalid) {
      this.markFormGroupTouched(this.roleForm);
      return;
    }
    const model = {
      id: this.id,
      sso: this.roleForm.controls.sso.value,
      email: this.roleForm.controls.email.value,
      fullName: this.roleForm.controls.fullName.value,
      roles: [this.roleForm.controls.roles.value],
      isPrimary: this.roleForm.controls.isPrimary.value ? this.roleForm.controls.isPrimary.value : false,
      accessType: this.roleForm.controls.accessType.value || false,
    };
    this.spinner.show();
    if (this.isEdit) {
      this.contractRoleService.updateRole(model).subscribe(res => {
        this.spinner.hide();
        this.toastr.success(MESSAGE_TOAST.UPDATE_ROLES);
        this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_CONTRACT_ACCESS]);
      });
    } else {
      this.contractRoleService.addRole(model).subscribe(res => {
        this.spinner.hide();
        this.toastr.success(MESSAGE_TOAST.ADD_ROLES);
        this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_CONTRACT_ACCESS]);
      });
    }
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }


}
